import { countAcceptedInOpeningWindow } from '../ledgerMetrics'
import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { bufferedTimeMs } from '../timeBuffer'

const STRONG_START_WINDOW_MS = bufferedTimeMs(10_000)
const STRONG_START_WORD_COUNT = 5

export const strongStartCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  if (!isAcceptedWordEntry(entry) || entry.atMs > STRONG_START_WINDOW_MS) {
    return false
  }
  const countNow = countAcceptedInOpeningWindow(ledger, index, STRONG_START_WINDOW_MS)
  if (countNow < STRONG_START_WORD_COUNT) {
    return false
  }
  const countBefore = countAcceptedInOpeningWindow(
    ledger,
    index - 1,
    STRONG_START_WINDOW_MS,
  )
  return countBefore < STRONG_START_WORD_COUNT
}
